import { styled } from 'styled-components';
import { spacing } from 'styles/helpers';

export const Card = styled.button`
  align-items: center;
  display: flex;
  gap: ${spacing['2xs']};
`;
